import { Button, Select } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, XStack } from "tamagui";

import { useResearchFilter } from "./filter-context";

export const ResearchSortBy = () => {
  const { t } = useTranslation("research");

  const { dispatch } = useResearchFilter();

  const options = t("research-list-page.filter.options", {
    returnObjects: true,
  });

  return (
    <XStack alignItems="center" gap={"$1"}>
      <Text
        color={"$gray-primary-900"}
        fontFamily={"$subtitle"}
        fontWeight={"$5"}
        fontSize={"$2"}
        lineHeight={"$2"}
      >
        {t("research-list-page.filter.title")}
      </Text>

      <Select
        trigger={(Value) => (
          <Button
            data-id="research-filter-sortby"
            width={"100%"}
            variant="gray"
            size={"sm"}
            rounded="lg"
          >
            <XStack gap={"$1"} alignItems="center">
              <Value
                fontFamily={"$subtitle"}
                fontWeight={"$5"}
                fontSize={"$2"}
                lineHeight={"$2"}
                color={"$gray-primary-900"}
                placeholder={t("research-list-page.filter.label")}
              />
            </XStack>
          </Button>
        )}
        defaultValue={options[0]?.value}
        onValueChange={(val) => {
          dispatch({
            type: "SET_FILTER",
            filterName: "sortBy",
            value: val,
          });
        }}
        label={t("research-list-page.filter.label")}
        items={options as unknown as { name: string; value: string }[]}
      />
    </XStack>
  );
};
